import { dashBoardConstants } from '../../_constants/dashBoard.constants';

const initialState = { invite_post_loading : true, invite_post: '', invite_post_error: false};

export function invitePost(state = initialState, action) {
    switch (action.type) {
        case dashBoardConstants.REQUEST_INVITE_POST:
        return {
            invite_post_loading: true,
            invite_post: '',
            invite_post_error: false
        };
      case dashBoardConstants.RECIEVE_INVITE_POST:
        return {
            invite_post_loading: false,
            invite_post: action.invite_post,
            invite_post_error: false
        };
      case dashBoardConstants.ERROR_INVITE_POST:
        return { 
            invite_post_loading: false,
            invite_post: '',
            invite_post_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/dashBoard/invitePost.reducer.js